import React, { useEffect, useState, useRef } from "react";
import { message, notification } from 'antd';
import { Base64 } from "js-base64";
import dayjs from 'dayjs';
import * as moment from "moment-timezone";
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import { Col, Row } from "react-awesome-styled-grid";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    addCheckoutPageChargeById,
    BASE_URLS,
    declinePaymentLinkByGid,
    getCheckoutPageById,
    getCheckoutCardCharges,
    getCheckoutReconnection,
    getSecretValuesById,
    getQrPaymentReconnection,
    getHealthCheck,
    getCheckoutChallanCharges,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../api";
import {
    MESSAGES,
    PAYMENT_LINK_STATUSES,
    SWIREPAY_URL, TabNames,
    expireyText,
    ACCOUNT_MDR,
    NETBANKING_LIST,
    QR_STATUSES,
    REFRENCE_ID_LENGTH,
    TANGEDCO_PG,
    SESSION_TIME,
    LPG_CUSTOMER,
} from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/footer";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/UpiCheckout/UpiCheckout";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import ChallanPayment from "../../components/challanpayment/ChallanPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import PayPalCheckout from "../paypalCheckout";
import ApplePay from "../../components/applePay/ApplePay";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";
import RecaptchaModal from "../../components/recaptcha";
import Apple from '../../routes/apple';
import ApplePayButton from '../../routes/apple/PayPalApplePay';
import PayPalGooglePay from "../../components/payPalGooglePay";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";

type Props = {
    history: {
        push: Function,
    },
}

const PaymentLink = (props: Props) => {

    const { match: { params: { checkoutPageId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${checkoutPageId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [count, setCount] = useState(0);
    const [timer, setTimer] = useState(true);
    const [convenience, setConvenience] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(null);
    const [userType, setUserType] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [supportPhoneNumber, setSupportPhoneNumber] = useState(null);
    const [upiError, setUpiError] = useState('');
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [ipAddress, setIpAddress] = useState('');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [applePayment, setApplePayment] = useState(false);
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const accountGid = [
        'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${checkoutPageId}`) || undefined);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [paypalGooglePayRecaptchaToken, setPaypalGooglePayRecaptchaToken] = useState(null);
    const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();
    const paymentSessionGidRef = useRef(null);
    const redirectUrlRef = useRef(null);
    const upiAppPsClientSecretRef = useRef(null);

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    useEffect(() => {
        if (payment?.account?.gid) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    useEffect(() => {
        if (search) {
            getPaymentLinkDataWithSearchValue();
        } else {
            getPaymentLinkDataWithoutSearchValue();
        }
    }, [checkoutPageId, search]);

    useEffect(() => {
        if (updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails) {
            if (updateCustomerRedux?.customerDetails?.name && updateCustomerRedux?.customerDetails?.name !== '') {
                setPayment((prev) => ({ ...prev, name: updateCustomerRedux.customerDetails.name }));
            };
            if (updateCustomerRedux?.customerDetails?.email && updateCustomerRedux?.customerDetails?.email !== '') {
                setPayment((prev) => ({ ...prev, email: updateCustomerRedux.customerDetails.email }));
            };
            if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
                && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
            ) {
                setPayment((prev) => ({ ...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
            };
            dispatch(setUpdateStatus(false));
        };
    }, [updateCustomerRedux]);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useState(() => {
        if (window.ApplePaySession) {
            setIsApplePay(true);
        }
    }, []);

    useEffect(() => {
        getData();
        setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
    }, []);

    useEffect(() => {
        if (payment && payment.currency && payment.amount) {
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency.name));
        }
        console.log(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'))
        if (payment && payment.account && payment.account.gid) {

            setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
            setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
            setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
            if (TANGEDCO_PG === payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    setPaymentTypeOrder([{ category: 'CARD' }]);
                } else setSupportedPaymentTypes(['CARD']);
                // setUpiError('UPI/QR is temporarily down');
            } else if (TANGEDCO_PG !== payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    const paymentMethod = payment && payment.paymentMethodType;
                    const paymentOrders = payment && payment.account && payment.account.paymentTypeOrder;
                    const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
                    let newfilterPaymentOrder;
                    if (payment.account && paymentMethod.includes('WALLET')) {
                        setPaymentTypeOrder(filterPaymentOrder);
                    } else {
                        newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                        setPaymentTypeOrder(newfilterPaymentOrder);
                    }
                } else {
                    setSupportedPaymentTypes(payment && payment.paymentMethodType);
                }
            }
        }
        setSupportPhoneNumber(payment && payment.support && payment.support.phone);
    }, [payment]);

    useEffect(() => {
        setErrorMessage(null);
        if (payment && payment.currency && payment.amount) {
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency.name));
        }
        setConvenience(0);
        setGst(0);
    }, [selectedTab]);

    useEffect(() => {
        if (!timer) {
            setTimeout(() => {
                const newCount = count - 1;
                setCount(newCount >= 0 ? newCount : 0);
                if (newCount <= 0) {
                    if (payment && payment.redirectUri) {
                        window.location = payment.redirectUri;
                    } else {
                        props.history.push(`${pathname}/expired`);
                    }

                }
            }, 1000);
        }
    }, [count]);

    useEffect(() => {
        if (payment && payment.expiresAt && timer) {
            const startDate = new Date();
            const endDate = moment.utc(payment.expiresAt);
            const seconds = (endDate._d.getTime() - startDate.getTime()) / 1000;
            if (timer) {
                setCount(Math.trunc(seconds));
                setTimer(false);
            }
        }
    }, [payment]);

    const getGooglePayMerchantValues = async (accountGid) => {
        try {
            const values = await getSecretValuesById(accountGid, null);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support')
        }
    };

    const getPaymentLinkDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        let paymentIfo;
        setShowSpinner(true);
        try {
            const value = await getCheckoutPageById(checkoutPageId, search);
            if (value) {
                const { redirectUri, status } = value;
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (PAYMENT_LINK_STATUSES.ACTIVE !== status) {
                    if (!redirectUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectUri ? redirectUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${checkoutPageId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${checkoutPageId}`;
                        }
                    }, timeOut);
                }
            }
        } catch (reason) {
            try {
                const value = await getCheckoutPageById(checkoutPageId, null);
                if (value) {
                    paymentIfo = value;
                    setPayment(value);
                    dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                      value: {
                        phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
                        countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
                        name: value?.name,
                        email: value?.email,
                      } 
                    }));
                    setUserType(value.account && value.account.mdr);
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        setBankImageUrl(value.account && value.account.bankImageUrl);
                        setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                        if (portal) {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                            setBanksList(supportedBanks);
                        } else {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                            setBanksList(supportedBanks);
                        }
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            window.location = paymentIfo && paymentIfo.redirectUri;
            // error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getPaymentCharges = async (cardNumber, payments) => {
        setPayment(payments);
        dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
          value: {
            phoneNumber: payments?.phoneNumber ? getCountryCodeAndNumber(payments?.phoneNumber)?.phoneNumber : '',
            countryCode: payments?.phoneNumber ? getCountryCodeAndNumber(payments?.phoneNumber)?.countryCode : '+1',
            name: payments?.name,
            email: payments?.email,
          } 
        }));
        try {
            let value = null;
            if (null != cardNumber) {
                value = await getCheckoutCardCharges(checkoutPageId, cardNumber);
            } else {
                value = await getCheckoutChallanCharges(checkoutPageId);
            }
            if (value) {
                setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
                setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payments.amount + value.feeAmount + value.taxAmount), payments.currency.name)}`)
                setTotalAmount(currencyFormatter(AmountDivideByHundred(payments.amount + value.feeAmount + value.taxAmount), payments.currency.name));
            }
        } catch (e) {
            setConvenience(0);
            setGst(0);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payments.amount), payments.currency.name));
        } finally {
            setShowSpinner(false)
        }
    }

    const getPaymentLinkDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getCheckoutPageById(checkoutPageId, null);
            if (value) {
                const { status, redirectUri } = value;
                if (PAYMENT_LINK_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                    phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
                    countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
                    name: value?.name,
                    email: value?.email,
                  } 
                }));
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                        setBanksList(supportedBanks);
                    } else {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                        setBanksList(supportedBanks);
                    }
                }
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                setUserType(value.account && value.account.mdr);
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByNetBanking = async (data) => {
        const { gid } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };


    const chargeByUpi = async (data) => {
        const { paymentMethod } = data;
        const userAgent = {
          acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
          ip: ipAddress,
          language: window.navigator.language,
          colorDepth: window.screen.colorDepth,
          screenHeight: window.screen.height,
          screenWidth: window.screen.width,
          timeZone: new Date().getTimezoneOffset(),
          browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        await addCheckoutPageById({
          paymentMethod,
        });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await addCheckoutPageById({ customer, paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias } = data;
        const paymentMethod = {
            type: "WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };


    const chargeByCard = async (data) => {
        const { paymentMethod } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        await addCheckoutPageById({ paymentMethod });
    };
    const generateChallan = async (data) => {
        await addCheckoutPageById(data);
    };

    const chargeBySavedPaymentMethods = async (data) => {
      await addCheckoutPageById({ paymentMethod: data });
    };

    const chargeByBank = async (data) => {
        const { customer, fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await addCheckoutPageById({ customer, paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByPaypalGooglePay = async (data) => {
        // const paymentMethod = {
        //     type: "WALLET",
        //     subType: "GOOGLE_PAY_US",
        //     googlePayUS: {
        //         apiVersionMinor: data.apiVersionMinor,
        //         apiVersion: data.apiVersion,
        //         paymentMethodDescription: data.paymentMethodData.description,
        //         paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
        //         paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
        //         paymentMethodType: data.paymentMethodData.type,
        //         paymentMethodInfo: data.paymentMethodData.info
        //     },
        // };
        // await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
        try {
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                const responseEntity = await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, paypalGooglePayRecaptchaToken);
                isPayPalGoogle.current = false;
                const orderId = await getMrn(responseEntity.paymentSession.gid, responseEntity.paymentSession.psClientSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(responseEntity.paymentSession.gid, responseEntity.paymentSession.psClientSecret);
                chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
            chargeByIdFailActions();
        }
    };
    
    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        setRecaptchaPaymentType('cardPointGooglePay');
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, cardPointGooglePayToken);
    };

    const chargeByApple = async (paymentData, recaptchaToken = null) => {
      const {
        deviceData,
        // amount,
        customerName,
        customerEmail,
        customerPhone,
        countryCode,
        stateCode,
        street,
        postalCode,
        city,
        cardNetwork,
        cardType,
        cardLast4,
      } = paymentData;
      const billingAddress = {
          city: city,
          countryCode: countryCode,
          state: stateCode,
          street: street
        };
      setRecaptchaPaymentType('paypalApplePay');

      const paymentMethod = {
        applePayUS: {
          deviceData: deviceData,
          cardBrand: cardNetwork,
          cardFundingType: cardType,
          applePayDynamicLast4: cardLast4,
          cardLast4: cardLast4
        },
        type: "WALLET",
        subType: "APPLE_PAY_US",
        postalCode: postalCode,
        paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
      }
      let customer = {
          email: customerEmail,
          name: customerName,
          phoneNumber: customerPhone
      }
      const value = await getPayPalAccountInfo(payment?.account?.gid);
      if (value) {
        isPayPalApple.current = true;
      }
      const responseEntity = await addCheckoutPageById({
          paymentMethod: paymentMethod,
          customerGid: getCustomerGidFromPayment(payment),
          customer: customer
      });
      isPayPalApple.current = false;
      responseEntity.paymentSessionGid = responseEntity?.paymentSession?.gid;
      responseEntity.psClientSecret = responseEntity?.paymentSession?.psClientSecret;
      return responseEntity;
    }

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
      
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }

        await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer
        }, null);
    };


    const chargeByApplePay = async (stripePaymentMethod, recaptchaToken = null) => {
        // const meta = stripePaymentMethod;
        const paymentMethod = {
            applePayUS: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.billing_details.name,
                email: stripePaymentMethod.billing_details.email,
                phone: stripePaymentMethod.billing_details.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.name,
                email: stripePaymentMethod.email,
                phone: stripePaymentMethod.phone
            }
        };
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
            isPayPalApple.current = true;
        }
        const responseEntity = await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, recaptchaToken);
        isPayPalApple.current = false;
        return responseEntity;
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
          case TabNames.UPI:
            setPaymentLinkUpiGlobalRecaptcha(token);
            break;
          case TabNames.INSTANT_PAYMENT:
            setPaymentLinkInstantPaymentGlobalRecaptcha(token);
            break;
          case 'paypalApplePay':
            setPaypalApplePayRecaptcha(token);
            setPaypalApplePayMessageModal(true);
            break;
          case 'paypalGooglePay':
            setPaypalGooglePayRecaptchaToken(token);
            break;
          case 'cardPointGooglePay':
            setCardPointGooglePayToken(token);
            break;
          case 'payPalButton':
            commonRecaptchaToken.current = token;
            break;
          default:
            addCheckoutPageById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
      }

    
    const chargeByUpiIndent = async (data) => {
        try {
            const value = await addCheckoutPageChargeById(checkoutPageId, data);
            if (value) {
                const { nextActionUrl, redirectUri } = value;
                paymentSessionGidRef.current = value?.paymentSession?.gid;
                upiAppPsClientSecretRef.current = value?.paymentSession?.psClientSecret;
                redirectUrlRef.current = redirectUri;
                return (nextActionUrl || null);
            }
            return null;
        } catch (reason) {
            setTimeout(function () {
                window.location = payment && payment.redirectUri;
            }, 1000);
            // error(reason);
        }
    };

    const onReturnFromUpiApp = async () => {
      // call action
      setTransactionModalOpen(true);
      try {
        if (paymentSessionGidRef?.current && upiAppPsClientSecretRef?.current) {
          // poll to check if the transaction has processed
          let entity;
          let attempts = 0;
          const MAX_ATTEMPTS = 15; // poll every 1s for upto 15 seconds
          const POLLING_INTERVAL = 1000;
          while (attempts < MAX_ATTEMPTS) {
            entity = await action(paymentSessionGidRef?.current, upiAppPsClientSecretRef?.current);
            if (entity?.status === 'REQUIRE_ACTION') {
              await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
              attempts++;
            } else {
              break;
            }
          }
          setTransactionModalOpen(false);
          const timeOut = redirectUrlRef?.current ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
          if (entity?.status === 'SUCCEEDED') {
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const redirectUrl = redirectUrlRef?.current ? redirectUrlRef?.current : SWIREPAY_URL;
                const urlPath = redirectUrl.includes("?");
                if (urlPath) {
                    window.location = `${redirectUrl}&sp-checkout-page=${checkoutPageId}`;
                } else if (!urlPath) {
                    window.location = `${redirectUrl}?sp-checkout-page=${checkoutPageId}`;
                }
                sessionStorage.removeItem("stripeRes");
              }, timeOut);
              return;
          } else {
            const redirectUrl = redirectUrlRef?.current ? redirectUrlRef?.current : SWIREPAY_URL;
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
                window.location = `${redirectUrl}&sp-checkout-page=${checkoutPageId}`;
            } else if (!urlPath) {
                window.location = `${redirectUrl}?sp-checkout-page=${checkoutPageId}`;
            }
            sessionStorage.removeItem("stripeRes");
          }
        }
      } catch (e) {
        console.error(e);
      }
    };

    const chargeByIdSuccessActions = async (value) => {
        const { nextActionUrl, redirectUri } = value;
        setTransactionModalOpen(true);
        const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
            const redirectUrl = redirectUri ? redirectUri : SWIREPAY_URL;
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
                window.location = `${redirectUrl}&sp-checkout-page=${checkoutPageId}`;
            } else if (!urlPath) {
                window.location = `${redirectUrl}?sp-checkout-page=${checkoutPageId}`;
            }
            sessionStorage.removeItem("stripeRes");
        }, timeOut);
        if (checkoutPageId) { localStorage.removeItem(`${checkoutPageId}-tap-index`) }
    };



    const addCheckoutPageById = async (data) => {
        setTransactionModalOpen(true);
        try {
            const value = await addCheckoutPageChargeById(checkoutPageId, data);
            if (value) {
              if (!isPayPalApple.current
                && !isPayPalGoogle.current
              ) {
                await chargeByIdSuccessActions(value);
              }
              return value;
            }
        } catch (reason) {
            if (reason?.status === 429) {
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            setTimeout(function () {
                window.location = payment && payment.redirectUri;
            }, 1000);
            // error(reason);
        }
    };

    const getCheckoutById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${checkoutPageId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${checkoutPageId}`;
                        }
                    }, timeOut);
                    if (checkoutPageId) { localStorage.removeItem(`${checkoutPageId}-tap-index`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${checkoutPageId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${checkoutPageId}`;
                        }
                    }, timeOut);
                    if (checkoutPageId) { localStorage.removeItem(`${checkoutPageId}-tap-index`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true, isOpen: true, hideBtn: false,
            cancel: resetAlertConfig, header: "Are you sure!", body: "You will not be able to recover this payment link",
            submitBtnText: "Yes, decline it!", cancelBtnText: "Cancel", showCancelBtn: true,
            showSubmitBtn: true, submit: declinePaymentLink, icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const chargeByIdFailActions = async () => {
        setTransactionModalOpen(false);
    };

    const declinePaymentLink = () => {
        setAlertConfig({
            ...defaultAlertConfig,
            showIcon: true, isOpen: true, hideBtn: true,
            header: `Please Wait!. Your payment link decline is being processed`, body: "You will be redirected when the decline is successful.",
        });
        if (payment && payment.gid) {
            declinePaymentLinkByGid(payment.gid).then(value => {
                if (value) {
                    const { redirectUri } = value;
                    const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                    setAlertConfig({
                        ...defaultAlertConfig,
                        showIcon: true, isOpen: true, hideBtn: true,
                        header: "PaymentLink Decline Completed", body: "You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = redirectUri || SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        const decline = "decline=true";
                        if (urlPath) {
                            window.location = `${redirectUrl}&${decline}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?${decline}`;
                        }
                    }, timeOut);
                }
            }).catch(reason => error(reason));
        }
    };

    const onApprove = async (data) => {
        try {
            await confirmWalletOrderInfo(orderDatas?.paymentSessionGid, orderDatas?.psClientSecret);
            setTransactionSuccessModalOpen(true);
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const createOrder = async (paypalData, actions) => {
        try {
            let data = {};
            if (paypalData?.paymentSource === 'paypal') {
                data = {
                    paymentMethodDetails: {
                        payPalWallet: {
                            rawData: {
                                experience_context: {
                                    payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                    landing_page: "LOGIN",
                                    return_url: SWIREPAY_URL,
                                    cancel_url: SWIREPAY_URL,
                                }
                            }
                        },
                        type: "WALLET",
                        subType: "PAYPAL_WALLET"
                    }
                }
            } else if (paypalData?.paymentSource === 'venmo') {
                data = {
                    paymentMethodDetails: {
                        venmo: {
                            rawData: {
                                experience_context: {
                                    payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                    landing_page: "LOGIN",
                                    return_url: SWIREPAY_URL,
                                    cancel_url: SWIREPAY_URL,
                                }
                            }
                        },
                        type: "WALLET",
                        subType: "VENMO"
                    }
                }
            }
            const value = addCheckoutPageChargeById(checkoutPageId, data);
            commonRecaptchaToken.current = null;
            if (value?.paymentSessionGid) {
                setOrderData(value)
                const orderData = await getWalletOrderInfo(value?.paymentSessionGid, value?.psClientSecret);
                if (!orderData.id) {
                    const errorDetail = orderData.details[0];
                    const errorMessage = errorDetail
                        ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                        : "Unexpected error occurred, please try again.";

                    throw new Error(errorMessage);
                }
                return orderData?.id;
            }
        } catch (error) {
            if (error?.status === 429) {
                setSavedPaymentDetails(paypalData);
                setRecaptchaPaymentType('payPalButton');
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                throw new Error('Recatpcha Required');
            }
            console.error(error);
            throw error || new Error('Unexpected error occurred, please try again.');
        }
    };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    if (uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS) {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if (!googlePayUs) {
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
            }
        }
    }
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;

        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                expireyText={expireyText}
                count={count}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={checkoutPageId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={payment && payment.canDecline}
                hideCustomer={true}
                showBillDetails={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                buttonText={submitBtnText}
                customerValidation={true}
                expireyText={expireyText}
                count={count}
                charges={true}
                convenience={convenience}
                gst={gst}
                prefix={payment && payment.currency && payment.currency.prefix}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.amount), payment && payment.currency && payment.currency.name)}`}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                chargeByApplePay={chargeByApplePay}
            />
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                isTest={isTest}
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                getCheckoutById={getCheckoutById}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                expireyText={expireyText}
                count={count}
                checkoutPageId={checkoutPageId}
                showMobileViewUpi={true}
                totalAmount={totalAmount}
                supportPhoneNumber={supportPhoneNumber}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                onReturnFromUpiApp={onReturnFromUpiApp}
                onChargeByUpiIndent={chargeByUpiIndent}
            />
            id = name;
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                checkoutPageId={checkoutPageId}
                iavUrl={`${BASE_URLS.PAYMENT_LINK}/${checkoutPageId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                expireyText={expireyText}
                count={count}
                requiredPhone={true}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                expireyText={expireyText}
                count={count}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.CHALLAN) {
            children = <ChallanPayment
                showCancelBtn={payment && payment.canDecline}
                hideCustomer={true}
                showBillDetails={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={generateChallan}
                preFillCustomer={payment}
                checkoutPageId={checkoutPageId}
                headerText={"Pay With Challan"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                expireyText={expireyText}
                count={count}

                prefix={payment && payment.currency && payment.currency.prefix}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.amount), payment && payment.currency && payment.currency.name)}`}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                userType={userType}
                payments={payment && payment}
                payment={payment}
                convenience={convenience}
                gst={gst}
                totalAmount={totalAmount}
            />
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                isTest={isTest}
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                getCheckoutById={getCheckoutById}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                expireyText={expireyText}
                count={count}
                checkoutPageId={checkoutPageId}
                showMobileViewUpi={true}
                totalAmount={totalAmount}
                supportPhoneNumber={supportPhoneNumber}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByPaypalGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={payment?.account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
              paypalGooglePayRecaptchaToken={paypalGooglePayRecaptchaToken}
            />
          ) : (
            <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                errorMsg={errorMessage}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorHeader={null}
            />
          )
        }
      </>
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByPaypalGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={payment?.account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
              paypalGooglePayRecaptchaToken={paypalGooglePayRecaptchaToken}
            />
          ) : (
            <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
          )
        }
      </>
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                expireyText={expireyText}
                headerText={"PAY WITH WALLET Alias"}
                count={count}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.CHECKOUT_PAGE}/${checkoutPageId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
            />
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                expireyText={expireyText}
                headerText={"PAY WITH WALLET Alias"}
                count={count}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.CHECKOUT_PAGE}/${checkoutPageId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={true}
                showBillDetails={true}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={true}
                expireyText={expireyText}
                count={count}
                charges={true}
                convenience={convenience}
                gst={gst}
                prefix={payment && payment.currency && payment.currency.prefix}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.amount), payment && payment.currency && payment.currency.name)}`}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                chargeByApplePay={chargeByApplePay}
            />,
            id: 'CARD'
        }
    ];

    const tabPanelsApple =
    {
        //children :  <Apple amount={AmountDivideByHundred(payment && payment.amount)} chargeByApple={chargeByApple} payment={payment}/>
        children:
            <>
                {
                    payPalClientAuth ? (
                        <ApplePayButton
                            recaptchaToken={paypalApplePayRecaptcha}
                            amount={payment && payment.amount}
                            chargeByApple={chargeByApple}
                            payment={payment}
                            accountGid={payment?.account?.gid}
                            successCallback={chargeByIdSuccessActions}
                            failCallback={chargeByIdFailActions}
                        />
                    ) : (
                        <>
                            {
                                applePayment && isApplePay ? <Apple amount={payment && payment.amount} chargeByApple={chargeByCardpointeApplePay} payment={payment} /> : null
                            }
                        </>
                    )
                }
            </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
    }
        ;

    tabPanels.push(tabPanelsApple);

    if (payment?.account?.country?.alpha2 === 'US') {
      tabPanels.push({
        children: <SavedPaymentMethods
                    buttonText={submitBtnText}
                    submit={chargeBySavedPaymentMethods}
                    supportedPaymentTypes={uniquePaymentTypes}
                  />,
        id: 'SAVED_PAYMENT_METHODS'
      });
    }

    if (payPalClientAuth && payPalClientId) {
      tabPanels.push({
      children: <div style={{ width: '200px'}}>
      <PayPalCheckout
        styles={{ shape: "rect", layout: "vertical" }}
        createOrder={createOrder}
        onApprove={onApprove}
        payPalClientId={payPalClientId}
        currency={payment?.account?.currency?.name || 'USD'}
        country={payment?.account?.country?.alpha2 || 'US'}
      />
      </div>,
      id: 'PAYPAL_METHOD',
      });
      uniquePaymentTypes.push('PAYPAL_METHOD');
    }    

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;

    return (
        <BaseSplitPage
            errorHeader={null}
            errorMsg={errorMessage}
            left={
                <>
                    <FlexContainer
                        flexDirection="column"
                        position="relative"
                        display="block"
                        height="100%"
                    >
                        <div>
                            {
                                (payment && payment.account && payment.account.largeLogo) && (
                                    <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                                )
                            }
                            <H1Text>
                                Payment Checkout
                            </H1Text>
                            <div className="mb-2" style={{ fontWeight: '400', fontSize: '14px', color: '#909090' }}>
                                Payment For
                            </div>
                            <Row>
                                <Col className="mt-2" style={{ fontWeight: '600', fontSize: '18px', marginLeft: "0px", color: '#1B1B1B' }}>
                                    {(payment && payment.description) || (payment && payment.account && payment.account.name)}
                                </Col>
                            </Row>
                            <div className="mt-3 mb-3" style={{ fontWeight: '400', fontSize: '13px', color: '#474747' }}>
                                <p>
                                    Reference Id: {
                                        (payment && payment.gid) ? (payment.gid).slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>
                                    }
                                </p>
                            </div>
                            {
                                tabName === 'UPI' && (
                                    <>
                                        <H2Text>
                                            Amount
                                        </H2Text>
                                        <DescriptionText fontSize="24px">
                                            {payment ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
                                        </DescriptionText>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ position: "sticky", top: "85%" }}>
                            <Support email={payment && payment.support && payment.support.email}
                                phone={payment && payment.support && payment.support.phone}
                                whiteLabel={payment && payment.account && payment.account.whiteLabel}
                                partnerImageUrl={partnerImageUrl}
                                bankImageUrl={bankImageUrl} />
                            {agregatorName === 'EPAYMENTS' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                    <a href="https://www.swirepay.com" target="_blank" >
                                        <img src={EPaymentImg} alt="" />
                                    </a>
                                </div>
                                :
                                agregatorName === 'OMEGAITR' ?
                                    <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                        <a href="https://www.swirepay.com" target="_blank" >
                                            <img src={OMEGAITRlogo} alt="" />
                                        </a>
                                    </div>
                                    :
                                    ''
                            }

                        </div>
                    </FlexContainer>
                </>
            } right={
                <>
                    <Header
                        payment={payment}
                        bankImageUrl={bankImageUrl}
                        tabName={tabName}
                        cancelUrlLink={null}
                    />
                    {payment?.account?.country?.alpha2 === 'US' ? (
                      <PaymentExpandableRowsV2
                          name={checkoutPageId}
                          paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                          tabs={uniquePaymentTypes}
                          tabPanels={tabPanels}
                          defaultSelectedTab={selectedTab || 0}
                          onSelect={data => setSelectedTab(data)}
                          tabName={tabName}
                          upiDown={upiDownTime}
                          applePayment={applePayment}
                          isApplePay={isApplePay}
                          accountGid={payment?.account?.gid}
                      />) : (
                        <PaymentExpandableRows
                          name={checkoutPageId}
                          paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                          tabs={uniquePaymentTypes}
                          tabPanels={tabPanels}
                          defaultSelectedTab={selectedTab || 0}
                          onSelect={data => setSelectedTab(data)}
                          tabName={tabName}
                          upiDown={upiDownTime}
                          applePayment={applePayment}
                          isApplePay={isApplePay}
                          accountGid={payment?.account?.gid}
                          amount={payment?.amount}
                          offerRequired={payment?.account?.enableAcquirerOffer || false}
                      />
                    )}
                    <SmallScreenFooter
                        partnerImageUrl={partnerImageUrl}
                        bankImageUrl={bankImageUrl}
                        whiteLabel={payment && payment.account && payment.account.whiteLabel}
                    />
                    <RecaptchaModal
                        visible={recaptchaModalVisible}
                        onVerified={onGlobalCaptchaVerified}
                    />
                    <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                    <SuccessModal isOpen={isTransactionSuccessModalOpen} />
                    <AlertModal
                        showIcon={alertConfig.showIcon}
                        isOpen={alertConfig.isOpen}
                        hideBtn={alertConfig.hideBtn}
                        cancel={alertConfig.cancel}
                        header={alertConfig.header}
                        body={alertConfig.body}
                        submitBtnText={alertConfig.submitBtnText}
                        cancelBtnText={alertConfig.cancelBtnText}
                        showCancelBtn={alertConfig.showCancelBtn}
                        showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                    <Spinner isOpen={isShowSpinner} />
                </>
            } />
    )
};

export default PaymentLink;
